import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateModelHighlightedKeys =
  (updatedKeys: Record<string, string>) => (model: Model) => {
    const prevHighlighted = model.modelData.highlighted;
    const highlighted =
      prevHighlighted && updatedKeys[prevHighlighted.key]
        ? {
            ...prevHighlighted,
            key: updatedKeys[prevHighlighted.key],
          }
        : prevHighlighted;

    setDataProperty<ModelData>(model)(
      model.modelData,
      'highlighted',
      highlighted
    );
  };
